
const convertTableData = (data, numberWithCommas) => {
  const headers = Object.keys(data[0]);
  const content = data.map((row) => {
    const newRow = headers.map(column => (typeof row[column] === 'number' ? numberWithCommas(row[column]) : row[column]));
    let newJson = {};
    headers.forEach((header, index) => {
      if(!header.endsWith("ID")) {
        newJson[header] = newRow[index];
      }
    })

    return newJson;
  })
  return content;
}
const isFloat = (value) => {
  const number = parseFloat(value);
  return !isNaN(number) && isFinite(value) && value.toString().includes('.');
}
export {
  convertTableData,
  isFloat
}
